// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PorterFootprintsModuleScss from "../styles/PorterFootprints.module.scss";

var styles = PorterFootprintsModuleScss;

function growth_item_component_generator(data, index) {
  return React.createElement("div", {
              key: index.toString(),
              className: styles["growth-item"]
            }, React.createElement("div", {
                  className: styles["growth-title"]
                }, data.text), React.createElement("div", {
                  className: styles["growth-desc"]
                }, data.sub_text));
}

function PorterFootprintsCmp(Props) {
  var porter_footprints_data = Props.porter_footprints_data;
  return React.createElement("div", {
              className: styles.container
            }, React.createElement("h2", {
                  className: styles["main-title"]
                }, porter_footprints_data.text.text), React.createElement("div", {
                  className: styles["growth-container"]
                }, porter_footprints_data.achievements.map(growth_item_component_generator)));
}

var make = PorterFootprintsCmp;

export {
  styles ,
  growth_item_component_generator ,
  make ,
}
/* styles Not a pure module */
